var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400391 5.90909C0.400391 2.65 3.05039 0 6.30948 0H14.4913C17.7504 0 20.4004 2.65 20.4004 5.90909V14.0909C20.4004 17.35 17.7504 20 14.4913 20H6.30948C3.05039 20 0.400391 17.35 0.400391 14.0909V5.90909ZM16.764 4.54581C16.764 4.04581 16.3549 3.63672 15.8549 3.63672C15.3549 3.63672 14.9458 4.04581 14.9458 4.54581C14.9458 5.04581 15.3549 5.4549 15.8549 5.4549C16.3549 5.4549 16.764 5.04581 16.764 4.54581ZM10.4004 5C13.1595 5 15.4004 7.24091 15.4004 10C15.4004 12.7591 13.1595 15 10.4004 15C7.6413 15 5.40039 12.7591 5.40039 10C5.40039 7.24091 7.6413 5 10.4004 5ZM6.30948 10C6.30948 7.74545 8.14585 5.90909 10.4004 5.90909C12.6549 5.90909 14.4913 7.74545 14.4913 10C14.4913 12.2545 12.6549 14.0909 10.4004 14.0909C8.14585 14.0909 6.30948 12.2545 6.30948 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c7991c097ba495322b81893b26e9a273.svg";
export { ForwardRef as ReactComponent };